<rappider-list-grid [config]="PROJECT_MODEL_RELATION_LIST_CONFIG"
                    [data]="projectModelRelations"
                    [loading]="isLoading"
                    (columnActionClick)="onDeleteModelRelation($event)"
                    (listActionClick)="navigateRelationCreatePage()"></rappider-list-grid>

<!-- Create Relation Modal for Canvas Mode -->
<rappider-modal *ngIf="isCanvasMode"
                [(visible)]="isCreateRelationModalVisible"
                [fullScreen]="true"
                [title]="'PROJECT_MODULE.PROJECT_MODEL_RELATION_CREATE_COMPONENT.ADD_MODEL_RELATION' | translate"
                [footer]="null"
                (cancelClick)="onCreateRelationModalClose()">
  <rappider-project-model-relation-create [isModalMode]="true"
                                         [modalSourceModelId]="activeProjectModelId"
                                         (modalClose)="onCreateRelationModalClose()">
  </rappider-project-model-relation-create>
</rappider-modal>
